/**
 * Insurance Constants
 * Coverage data, beneficiary relationships, and equipment types
 * for the MSIG Golfer Insurance product.
 */

// ===== COVERAGE DATA =====
export const COVERAGE_DATA = {
  sections: [
    {
      id: 1,
      title: "Section 1: Third Party Liability",
      titleTh: "ส่วนที่ 1: ความรับผิดต่อบุคคลภายนอก",
      amount: 500000,
      unit: "baht",
    },
    {
      id: 2,
      title: "Section 2: Bodily Injury to the Insured",
      titleTh: "ส่วนที่ 2: การบาดเจ็บทางร่างกายของผู้เอาประกันภัย",
      subCoverages: [
        {
          id: "2.1",
          label: "Death/Dismemberment/Permanent Disability",
          amount: 200000,
          unit: "baht",
        },
        {
          id: "2.2",
          label: "Temporary Total Disability",
          amount: 1000,
          unit: "baht/week",
          maxWeeks: 52,
        },
        {
          id: "2.3",
          label: "Partial Temporary Disability",
          amount: 1000,
          unit: "baht/week",
          maxWeeks: 52,
        },
        {
          id: "2.4",
          label: "Medical Expenses",
          amount: 20000,
          unit: "baht/accident",
        },
      ],
    },
    {
      id: 3,
      title: "Section 3: Golf Equipment",
      titleTh: "ส่วนที่ 3: อุปกรณ์การเล่นกอล์ฟ",
      amount: 20000,
      unit: "baht/loss",
    },
    {
      id: 4,
      title: "Section 4: Special Bonus for Hole-In-One",
      titleTh: "ส่วนที่ 4: โบนัสพิเศษสำหรับ Hole-In-One",
      subCoverages: [
        { id: "4.1", label: "Tournament", amount: 15000, unit: "baht" },
        { id: "4.2", label: "General Play", amount: 10000, unit: "baht" },
      ],
    },
  ],
  premium: 913.78,
  premiumCurrency: "baht",
  premiumInclusive: "tax",
  territorialLimit: "Thailand",
  underwriter: "MSIG Insurance (Thailand) Public Company Limited",
};

// ===== BENEFICIARY RELATIONSHIPS =====
export const BENEFICIARY_RELATIONSHIPS = [
  { value: "spouse", label: "คู่สมรส (Spouse)" },
  { value: "parent", label: "บิดา/มารดา (Parent)" },
  { value: "child", label: "บุตร (Child)" },
  { value: "sibling", label: "พี่น้อง (Sibling)" },
  { value: "other", label: "อื่นๆ (Other)" },
];

// ===== EQUIPMENT TYPES =====
export const EQUIPMENT_TYPES = [
  { value: "wood", label: "Wood (ไม้วูด)" },
  { value: "iron", label: "Iron (เหล็ก)" },
  { value: "wedge", label: "Wedge (เวดจ์)" },
  { value: "putter", label: "Putter (พัตเตอร์)" },
  { value: "golf-bag", label: "Golf Bag (ถุงกอล์ฟ)" },
  { value: "cart", label: "Golf Bag Carrying Cart (รถลากถุงกอล์ฟ)" },
];

// Default export
export default {
  COVERAGE_DATA,
  BENEFICIARY_RELATIONSHIPS,
  EQUIPMENT_TYPES,
};
